import { useEffect, useRef } from "react";
import "./NavUserDropdown.scss"
import { SplitButton } from "primereact/splitbutton";
import { MenuItem } from "primereact/menuitem";
import { To, useNavigate } from "react-router-dom";
import UserHeaderTemplate from "../UserHeaderTemplate/UserHeaderTemplate";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ReactDOMServer from "react-dom/server";
import { RoutePaths } from "src/resources/enum";
import Cookies from "js-cookie";
import { AUTH_TOKEN } from "src/resources/constant";
import { setToken } from "src/redux/slices/bMCProfileSlice";
import { resetBMCProfileData } from "src/redux/slices/bMCProfileSlice";
import { isCivilDefenseUser } from 'src/utils/helpers';
import useResize from "src/hooks/useResize";
import { getCitiesOptions } from "src/redux/slices/lookupSlice";

const NavUserDropdown = ({ toggleMobileMenu }: { toggleMobileMenu?: () => void }) => {

  const navigate = useNavigate();
  const userMenuRef = useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation(["common"]);
  const isLoggedIn = useSelector((state: any) => state.bMCProfile.token);
  const name = useSelector(
    (state: any) => state.bMCProfile.BMCData.name
  );

  const handleClick = (path: To) => {
    toggleMobileMenu?.();
    navigate(path);
  };

  const items: MenuItem[] = [
    {
      template: (
        <button onClick={() => handleClick(isCivilDefenseUser() ? RoutePaths.CDProfile : RoutePaths.Profile)}>
          {t("profile")}
        </button>
      ),
    },
    {
      template: (
        <button onClick={() => handleClick(isCivilDefenseUser() ? RoutePaths.CDDashboard : RoutePaths.Dashboard)}>
          {t("dashboard")}
        </button>
      ),
    },
    {
      template: (
        <button onClick={() => handleClick(RoutePaths.ChangePassword)}>
          {t("changePassword")}
        </button>
      ),
    },
    {
      template: <button onClick={() => logOutUser()}>{t("logout")}</button>,
    },

  ];
  const { isMobile } = useResize();

  useEffect(() => {

    const menuButtons = document.querySelectorAll(".username-menu-btn");
    const userTemplate = document.querySelector(
      ".user-header-template-container"
    );
    userTemplate?.remove();

    if (isLoggedIn) {

      const portalElement = document.createElement("div");
      portalElement.className = "user-header-template-container";
      portalElement.innerHTML = ReactDOMServer.renderToString(
        <UserHeaderTemplate name={name} />
      );
      const viewButton = menuButtons ? (isMobile ? menuButtons[1] : menuButtons[0]) : null
      viewButton?.appendChild(portalElement);
    }
  }, [userMenuRef?.current, isLoggedIn , name]);
  function logOutUser(): void {
    Cookies.remove(AUTH_TOKEN);
    dispatch(setToken("") as any);
    dispatch(resetBMCProfileData());
      dispatch(
              getCitiesOptions("bbfaefd1-1f21-e811-910c-00505686c522") as any
            );
    navigate(RoutePaths.Home);
  }

  return (
    <div className="user-menu d-flex align-items-center">
      <SplitButton
        ref={userMenuRef}
        buttonProps={{
          className: "user-btn",
          onClick: () => handleClick(isCivilDefenseUser() ? RoutePaths.Profile : RoutePaths.CDProfile),
        }}
        model={items}
        menuButtonClassName="username-menu-btn fit-content me-2 ms-2"
        menuClassName="dropdown-menu-items"
      />
    </div>
  )
}

export default NavUserDropdown